import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 48px;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #282E33;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #3B444C;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #22272B;
  border-radius: 8px 8px 0 0;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #8C9BAB;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #B6C2CF;
  }
`;

export const Form = styled.form`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  color: #B6C2CF;
  background: #22272B;
  transition: all 0.2s ease;

  &:focus {
    border-color: #579DFF;
    outline: none;
    background: #22272B;
  }

  &:hover {
    border-color: #465059;
  }

  &::placeholder {
    color: #8C9BAB;
  }
`;

export const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  color: #B6C2CF;
  background: #22272B;
  resize: vertical;
  min-height: 100px;
  transition: all 0.2s ease;

  &:focus {
    border-color: #579DFF;
    outline: none;
    background: #22272B;
  }

  &:hover {
    border-color: #465059;
  }

  &::placeholder {
    color: #8C9BAB;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(Button)`
  background: transparent;
  border: none;
  color: #B6C2CF;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SecondaryButton = styled(Button)`
  background: #465059;
  border: none;
  color: #B6C2CF;

  &:hover {
    background: #586470;
  }
`;

export const CreateButton = styled(Button)`
  background: #579DFF;
  border: none;
  color: white;

  &:hover:not(:disabled) {
    background: #398BFF;
  }

  &:disabled {
    background: #579DFF;
    opacity: 0.5;
  }
`;

export const HelperText = styled.span`
  font-size: 12px;
  color: #8C9BAB;
  margin-top: 4px;
`;